var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { AspectKeyAttached } from './1_attached/AspectKeyAttached';
import { AspectKeyEnabled } from './2_enabled/AspectKeyEnabled';
import { AspectKeyReduced } from './3_reduced/AspectKeyReduced';
import { AspectKeyActive } from './4_active/AspectKeyActive';
import { AspectKeyValue } from './5_value/AspectKeyValue';
import { traitRegistry } from '../../../../registry/Registry';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
export class AspectKeyGlobal {
    parent;
    traitKey;
    constructor(parent, traitKey) {
        this.parent = parent;
        this.traitKey = traitKey;
    }
    get aspectScope() {
        return this.parent;
    }
    get aspect() {
        return this.aspectScope.aspect;
    }
    get reg() {
        return traitRegistry.registry_object[this.traitKey];
    }
    get keyTraits() {
        return this.aspect.aspectImport.traitsWithImported.filter((trait) => trait.key === this.traitKey);
    }
    get keyAttached() {
        return new AspectKeyAttached(this);
    }
    get keyEnabled() {
        return new AspectKeyEnabled(this);
    }
    get keyReduced() {
        return new AspectKeyReduced(this);
    }
    get keyActive() {
        return new AspectKeyActive(this);
    }
    get keyValue() {
        return new AspectKeyValue(this);
    }
}
__decorate([
    memoize
], AspectKeyGlobal.prototype, "keyAttached", null);
__decorate([
    memoize
], AspectKeyGlobal.prototype, "keyEnabled", null);
__decorate([
    memoize
], AspectKeyGlobal.prototype, "keyReduced", null);
__decorate([
    memoize
], AspectKeyGlobal.prototype, "keyActive", null);
__decorate([
    memoize
], AspectKeyGlobal.prototype, "keyValue", null);
